import { nanoid } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

export function createNanoId(size?: number) {
  return nanoid(size);
}

export function createUuid() {
  return uuidv4();
}
